import { Button } from "@/components/common/Button";
import { postMatchingBonus } from "@/modules/auth/api/deposit/matching-bonus";

import { useUserStore } from "@/modules/auth/store/user";
import { useMatchingBonusValueStore } from "@/modules/matching-bonus/store/value";
import {
  useModalSuccessfulMatchingBonusStore,
} from "@/shared/store/modal";
import { logger } from "@/shared/utils/logger";
import { useTonConnectUI } from "@tonconnect/ui-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const WithdrawalMatchingBonus = () => {
  const [tonConnectUI] = useTonConnectUI();

  const [isLoadingWithdraw, setIsLoadingWithdraw] = useState(false);

  const { t } = useTranslation();
  const { tonPrice, price } = useUserStore();

  const { matchingBonus } = useUserStore();

  const { currentToken, setCurrentToken, setValue, setNet } =
    useMatchingBonusValueStore();

  const { openModal, openModalError } = useModalSuccessfulMatchingBonusStore();

  const oneTONInBTN = (1 * tonPrice) / price;

  const handleConnect = () => {
    tonConnectUI.openModal();
  };

  const handleClick = async () => {
    if (isLoadingWithdraw) return;

    try {
      setIsLoadingWithdraw(true);

      setNet("ton");
      setValue(`${matchingBonus.tokenAmount}`);

      const payload = await postMatchingBonus(
        "token",
        "TON",
        0
      );

      if (!payload && openModalError) {
        openModalError();

        return;
      }

      openModal();
    } catch (error) {
      logger.info("Failed to withdraw: ", error);

      if (openModalError) openModalError();
    } finally {
      setIsLoadingWithdraw(false);
    }
  };

  const disabled = Boolean(
    matchingBonus.tokenAmount < oneTONInBTN || !tonConnectUI.account?.address
  );

  return (
    <div className="flex flex-col gap-5 p-4 border-b border-divider box-content">
      {currentToken === "" && (
        <div className="flex flex-col gap-4">
          <div className="w-full flex items-center justify-between gap-4">
            <Button
              onClick={() => setCurrentToken("token")}
              text="BTN"
              mode="bezeled"
              size="large"
              className="w-full"
            />
          </div>
        </div>
      )}
      {currentToken !== "" && (
        <div className="flex items-center gap-4">
          <Button
            onClick={() => setCurrentToken("")}
            icon="arrow-left"
            mode="bezeled"
            size="large"
            className="text-[0.9375rem] !leading-[1.25rem]"
          />
          {disabled && !tonConnectUI.account?.address ? (
            <Button
              onClick={handleConnect}
              text={t("main-page.connect_wallet")}
              mode="bezeled"
              size="large"
              className="w-full"
            />
          ) : (
            <Button
              onClick={handleClick}
              text={`${t("withdraw-page.withdrawal")} BTN`}
              mode="bezeled"
              size="large"
              className="w-full"
              disabled={disabled}
              loading={isLoadingWithdraw}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default WithdrawalMatchingBonus;
